import { Await } from "react-router-dom";
import { PodcastPageContext } from "@app/types/Page";
import CustomError from "@components/Error/CustomError";
import { TRouteWithRedirect, useRouteContext } from "@sphtech/web2-core/ssr";
import { HttpStatusCode } from "axios";

import PodcastPageContent from "./PodcastPageContent";

export default function PodcastsPage(): React.ReactElement {
  const { context } =
    useRouteContext<TRouteWithRedirect<PodcastPageContext, string>>();

  if (context && context.statusCode !== HttpStatusCode.Ok) {
    // StatusCode is not 200
    return <CustomError statusCode={context.statusCode} />;
  }

  return (
    <Await resolve={context.payload} errorElement={<CustomError />}>
      {({ kind, data }) => {
        if (kind === "section") {
          return <PodcastPageContent {...{ data }} />;
        }

        // Default error page.
        return <CustomError statusCode={HttpStatusCode.NotFound} />;
      }}
    </Await>
  );
}
